document.querySelectorAll('.js-read-more-gain-control').forEach(function(header) {
    const readMoreText = header.querySelector('.read-more-text');
    const originalText = readMoreText.textContent.trim();
    const toggleText   = header.getAttribute('data-toggle-text') || 'Show less';

    header.addEventListener('click', function() {
        document.querySelectorAll('.gain-control-item__content.open').forEach(function(openContent) {
            if (openContent !== header.closest('.gain-control-item').querySelector('.gain-control-item__content')) {
                const openHeader = openContent.closest('.gain-control-item').querySelector('.js-read-more-gain-control .read-more-text');
                openContent.style.maxHeight = '0';
                openContent.classList.remove('open');
                if (openHeader) {
                    openHeader.textContent = openHeader.closest('.js-read-more-gain-control').getAttribute('data-original-text') || openHeader.textContent;
                }
            }
        });

        const content = header.closest('.gain-control-item').querySelector('.gain-control-item__content');
        if (content.classList.contains('open')) {
            content.style.maxHeight = '0';
            content.classList.remove('open');
            readMoreText.textContent = originalText;
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.classList.add('open');
            readMoreText.textContent = toggleText;
        }
    });

    header.setAttribute('data-original-text', originalText);
});

